import { combineReducers, configureStore } from "@reduxjs/toolkit";
// Persistence
import {persistStore, persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { comPaysSlice } from "./redux/slicercomPays";
import { comRegionSlice } from "./redux/slicercomRegion";
import {comLangueSlice} from "./redux/slicercomLangue";



const persistConfig = {
    key: "root",
    storage,
};

const multiReducer = combineReducers({
        ComPays: comPaysSlice.reducer,        
        ComRegion: comRegionSlice.reducer,
        ComLangue: comLangueSlice.reducer
})
const persistedReducer = persistReducer(persistConfig, multiReducer);

export const mainStore = configureStore({
    //reducer:{
        //ComPays: comPaysSlice.reducer,        
        //ComRegion: comRegionSlice.reducer,
        //ComLangue: comLangueSlice.reducer
   // } 
   reducer : persistedReducer
});

export  const persistor = persistStore(mainStore);